// Track how the visitor is interacting, so focus rings only appear for people
// who need them.
//
// The problem this solves: components that open an overlay (cart drawer,
// filter drawer, search) return focus to their trigger when they close, which
// is correct for accessibility. But that programmatic focus() makes several
// browsers match :focus-visible, so a mouse or touch user is left staring at a
// ring around a button they clicked ages ago.
//
// Browser heuristics for :focus-visible differ (Safari and Chrome disagree on
// programmatic focus), so modality is tracked here instead of trusted to them.
// Keyboard use re-enables rings immediately.
(function () {
  var root = document.documentElement;
  var POINTER = 'kodama-pointer';

  var usingPointer = function () {
    root.classList.add(POINTER);
  };

  var usingKeyboard = function (event) {
    // Only navigation keys count: typing inside a field must not flip the mode
    // and start painting rings around every button.
    if (event.key === 'Tab' || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      root.classList.remove(POINTER);
    }
  };

  document.addEventListener('pointerdown', usingPointer, true);
  document.addEventListener('touchstart', usingPointer, { capture: true, passive: true });
  document.addEventListener('keydown', usingKeyboard, true);
})();
